export default "__VITE_ASSET__D3jtQKLe__"